// These constants are injected via webpack environment variables.
// You can add more variables in webpack.common.js or in profile specific webpack.<dev|prod>.js files.
// If you change the values in the webpack config files, you need to re run webpack to update the application

// These constants are injected via webpack DefinePlugin variables.
// You can add more variables in webpack.common.js or in profile specific webpack.<dev|prod>.js files.
// If you change the values in the webpack config files, you need to re run webpack to update the application

declare const __DEBUG_INFO_ENABLED__: boolean;
declare const __VERSION__: string;
declare const __SERVER_API_URL__: string;
declare const __GITVERSION__: string;
declare const __GITBRANCH__: string;
declare const __GITCOMMITHASH__: string;
declare const __I18N_HASH__: string;

export const VERSION = __VERSION__;
export const DEBUG_INFO_ENABLED = __DEBUG_INFO_ENABLED__;
export const I18N_HASH = __I18N_HASH__;
export const SERVER_API_URL = __SERVER_API_URL__;
export const GITVERSION = __GITVERSION__;
export const GITBRANCH = __GITBRANCH__;
export const GITCOMMITHASH = __GITCOMMITHASH__;

// CAPTCHA_ENABLED configuration
// Set to true to enable captcha functionality in the application
export const CAPTCHA_ENABLED: boolean = true;

// Feature flag to enable/disable phone acquisition on profile edit
export const PHONE_ACQUISITION_ENABLED = false;
export const PHONE_VALIDATION_ENABLED = true;
export const NOT_ALLOWED_ORGANIZATION = 'NOT_ALLOWED_ORGANIZATION';
export const CURRENTPOLICYVERSION = 'mef-policy.v10';
